import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { type ThirdPartyConfigsBootstrap } from '../../../constants/schemas/3p-config';
import { SearchPageResultsBannerPlacement, type useOAuthHandlers } from '../search-page-results-banner-placement';

const styles = cssMap({
	quickFindPlacementContainer: {
		paddingBottom: token('space.075'),
		paddingLeft: token('space.100'),
		paddingRight: token('space.100'),
	},
});

interface QuickFindBannerPlacementProps {
	thirdPartyConfigs: ThirdPartyConfigsBootstrap;
	availableProductsOrder: string[]; // Product keys in display order; connectors will be shown in this order
	useOAuthHandlers: useOAuthHandlers;
}

export const QuickFindBannerPlacement = ({
	thirdPartyConfigs,
	availableProductsOrder,
	useOAuthHandlers,
}: QuickFindBannerPlacementProps): React.JSX.Element | null => {
	return (
		<Box xcss={styles.quickFindPlacementContainer}>
			<SearchPageResultsBannerPlacement
				placementId="search-page-results-quick-find"
				thirdPartyConfigs={thirdPartyConfigs}
				availableProductsOrder={availableProductsOrder}
				useOAuthHandlers={useOAuthHandlers}
			/>
		</Box>
	);
};
